import { IPagesToHide } from "pages/[tenant]/console/types";

export const pagesToHideConsolePageSideBar: IPagesToHide = [] as IPagesToHide;

export const mobileFeatureNotInPlanTemplateBreakpoint = 550;
